export function parseDateCreated(dateCreated: string): Date {
  const dateMatches = dateCreated.match(/\d{2,4}[-\.]\d{2}[-\.]\d{2,4}/);
  let dateString = "";
  if (dateMatches) {
    dateString = dateMatches[0];
  } else {
    return new Date("1970-01-01T00:00:00.000Z");
  }

  const dateParts = dateString.split(/[-\.]/);
  const year = dateParts[0].length == 4 ? parseInt(dateParts[0]) : parseInt(dateParts[2]);
  const month = parseInt(dateParts[1]) - 1;
  const day = dateParts[0].length == 4 ? parseInt(dateParts[2]) : parseInt(dateParts[0]);

  let timeString = "";
  const timeMatches = dateCreated.match(/\d{2}:\d{2}/);
  if (timeMatches) {
    timeString = timeMatches[0];
  } else {
    timeString = "00:00";
  }

  const timeParts = timeString.split(":");
  const hours = parseInt(timeParts[0]);
  const minutes = parseInt(timeParts[1]);

  return new Date(year, month, day, hours, minutes);
}
